import { render, staticRenderFns } from "./StudyForm.vue?vue&type=template&id=d154e32a&scoped=true&"
import script from "./StudyForm.vue?vue&type=script&lang=js&"
export * from "./StudyForm.vue?vue&type=script&lang=js&"
import style0 from "./StudyForm.vue?vue&type=style&index=0&id=d154e32a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d154e32a",
  null
  
)

/* custom blocks */
import block0 from "./StudyForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports